<template>
	<div class="joinUsDiv">
		<!-- banner -->
		<div class="banner">
			<img src="../../assets/img/why.jpg" alt="">
		</div>
		<!-- main -->
		<div class="main">
			<!-- 为什么加入我们 -->
			<div class="why">
				<div class="homeTitle">
					<div class="homeTitleText">为什么加入煜豆</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="whyCon" id="why">
					<div class="whyConImg">
						<img src="../../assets/img/about_b_img1.jpg" alt="">
					</div>
					<div class="whyConItem">
						<div class="whyConItemChild">
							<div>
								<h3>智慧链接，美好生活</h3>
								<p>煜豆长期致力于智慧建筑平台和数字内容两大核心业务，积极拥抱产业互联网，努力成为行业数字化助手。</p>
							</div>
						</div>
						<div class="whyConItemChild">
							<div>
								<h3>用行动关心你的成长</h3>
								<p>这里富有挑战和影响力的内容，完备的职业培养和晋升体系，以及灵活的内容转岗机制，引领你发现更多可能。</p>
							</div>
						</div>
						<div class="whyConItemChild">
							<div>
								<h3>迎接每个特别的你</h3>
								<p>自由包容的文化氛围让你自由发挥，你的声音会被认真聆听，在这里，你不只是遇到同事，更是并肩成长的伙伴。</p>
							</div>
						</div>
						<div class="whyConItemChild">
							<div>
								<h3>福利关怀浸透你的生活</h3>
								<p>你的努力会被铭记，你的付出会被真诚对待，舒适与科技融合的办公室，极具竞争力薪酬和激励体制，完善和个性化员工福利，只为回报你的付出和拼搏。</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 招聘信息 -->
			<div class="job">
				<div class="firstdayss">
					<p>我们优雅地编写智慧建筑平台， 书写着智慧建筑的诗和远方</p>
					<p>我们从项目级到城市级， 践行数据在智慧建筑间驰骋</p>
					<p>我们踏上一条挑战之路——极目所望， 即为方向</p>
					<p>我们踏上一条无畏之路——携手伙伴， 一路同行</p>
					<p>我们踏上一条未来之路——路在脚下，梦在远方</p>
					<p>未来智慧建筑的每一寸光阴， 期待您的共同参与</p>
				</div>
				<!-- <div ></div> -->
				<div class="homeTitle">
					<div class="homeTitleText">诚聘英才</div>
					<div class="homeTitleLine" id="job">
					</div>
				</div>
				<div class="jobCon">
					<!-- 开始 -->
					<el-collapse v-model="activeNames">
						<el-collapse-item name="1">
							<template slot="title">
								<div class="jobConLeft">
									<div>
										<p>JAVA工程师(7000-21000)</p>
									</div>
									<div>
										<p>
											上海
										</p>
									</div>
								</div>
								<div class="jobConRight">
									<p>2023-2-27更新</p>
								</div>
							</template>
							<div>


								<h3>职位描述：</h3>
								<p>1．参与软件系统需求分析；熟悉系统开发环境，完成系统框架和核心代码；</p>
								<p>2．根据开发规范与流程独立完成模块的设计、编码、测试以及相关文档；</p>
								<p>3．参与系统核心模块的程序编码工作；</p>
								<p>4．参与软件工程师的日常开发工作；解决开发中的技术问题；</p>
								<p>5．参与软件需求与设计审核和代码检查；</p>
								<p>6．参与方案讨论和技术调研、负责方案设计和文档更新。</p>
								<p></p>
								<p></p>
							</div>
							<div>
								<h3>任职要求：</h3>
								<p>1．1年以上java开发经验，本科及以上学历，计算机及相关专业毕业；</p>
								<p>2．精通java主流开源框架，有读过源代码；</p>
								<p>3．熟练掌握管理工具；</p>
								<p>4．熟练掌握SQL语句，具备oracle、mysql等数据库开发经验；</p>
								<p>5．熟悉前端框架vue的应用开发；</p>
								<p>6．熟练掌握SQL语句，存储过程开发，具备oracle、mysql等数据库开发经验，能够进行SQL语句的优化；</p>
								<p>7. 工作踏实严谨，学习能力强，有较强的责任心；</p>
								<p>8. 性格开朗，具有良好的沟通和团队协作能力，具有较强的事业心与责任感。</p>
							</div>
						</el-collapse-item>
						<el-collapse-item name="2">
							<template slot="title">
								<div class="jobConLeft">
									<div>
										<p>WEB工程师(8000-15000)</p>
									</div>
									<div>
										<p>
											上海
										</p>
									</div>
								</div>
								<div class="jobConRight">
									<p>2023-2-27更新</p>
								</div>
							</template>
							<div>
								<h3>职位描述：</h3>
								<p>1. 负责Web前端页面的开发和复杂UI设计;</p>
								<p>2. 负责Web前端的技术选型;</p>
								<p>3. 负责Web前端的技术研究和知识储备，以适应新的业务需求;</p>
								<p>4. 与后端攻工程师配合，高质量完成Web前端的开发和维护;</p>
								<p>5. 配合项目经理，结合前端技术完善或改进Web的交互方式;</p>
								<p>6. 协助项目经理做好研发项目管理工作， 完成项目经理交办的相关事务。</p>

							</div>
							<div>



								<h3>任职要求：</h3>
								<p>1. 全日志本科及以上学历，计算机相关专业;</p>
								<p>2. 3年或以上web开发工作经验;</p>
								<p>3. 深入理解web前端技术(HTML, XML, CSS, JavaScript, Ajax等);</p>
								<p>4. 深入理解Web标准，熟悉各种常见的游览器，熟练掌握多种设备兼容问题;</p>
								<p>5. 熟练掌握多种前端调试工具和调试方法，有充足的JS性能调优经验;</p>
								<p>6. 深入理解MVVM， MVC等常见设计模式，熟练使用React，Vue，Angular其中一个或多个; </p>
								<p>7. 了解各终端应用上架流程，能够独立完成终端应用的上架发布，如微信小程序，lOS上架等。</p>
								<p>8. 工作踏实严谨，学习能力强，有较强的责任心。 </p>
								<p>9. 性格开朗，具有良好的沟通能力和团队协作能力，具有较强的事业心与责任感。</p>
							</div>
						</el-collapse-item>
						<el-collapse-item name="3">
							<template slot="title">
								<div class="jobConLeft">
									<div>
										<p>BIM平台开发主管(15000-26000)</p>
									</div>
									<div>
										<p>
											上海
										</p>
									</div>
								</div>
								<div class="jobConRight">
									<p>2023-2-27更新</p>
								</div>
							</template>
							<div>
								<h3>职位描述：</h3>
								<p>1. 负责公司所有的产品规划和产品设计，以及领导项目技术团队人员，推进产品研发跌代工作;</p>
								<p>2. 参与开发项目整体策划， 根据客户要求制定项目执行的开发流程。</p>
								<p>3. 负责技术团队的管理，包括相关技术人员的招聘技术测评， 培训，考核评估，工作安排等工作;</p>
								<p>4. 负责编写产品需求文档， 对产品功能和性能等进行定义描述，完成研发交底澄清;</p>
								<p>5. 参与产品UE/UI设计，用户交互体验的策划和提升;</p>
								<p>6. 负责跟踪整理产品运行反馈报告， 持续改进标杆用户的产品体验;</p>
								<p>7. 与各部门协同沟通，监督并确保技术团队工作流程的质量和进度;</p>
								<p>8. 根据相关程序技术项目进程和技术问题，与客户协商沟通处理;</p>
								<p>9. 处理项目或开发只出现的疑难任务或问题， 并制定出解决方案;</p>
								<p>10. 负责产品的是市场分析和竞品分析， 策划并提升产品核心竞争力;</p>
								<p>11. 配合市场人员进行产品方案的推广策划，收集需求，需求管理分析，方案设计和推进实施。</p>

							</div>
							<div>


								<h3>任职要求：</h3>
								<p>1. 本科及以上学历，计算机，软件工程，自动化，建筑等相关专业;</p>
								<p>2. 3年或以上软件开发工作经验，具有信息化平台项目开发经验者优先;</p>
								<p>3. 2年以上优秀团队技术管理经验，具有项目和员工的管理经验;</p>
								<p>4. 熟悉NET，JAVA，C++，C#等语言，熟悉数据库技术;</p>
								<p>5. 对建筑行业，BIM等相关技术有一定理解，了解大数据，工业化联网，物联网等行业发展趋势;</p>
								<p>6. 熟悉当前主流BIM建模软件平台;</p>
								<p>7. 熟悉数据结构基础，算法基础以及数据库设计范围;</p>
								<p>8. 具备项目重难点代码编写和规划能力， 能够带团队解决项目重难点技术问题。</p>
								<p>9. 性格开朗，具备良好的沟通协调能力， 思路清晰，表达流畅， 较好的心理素质和工作承压能力。</p>
							</div>
						</el-collapse-item>
						<el-collapse-item name="4">
							<template slot="title">
								<div class="jobConLeft">
									<div>
										<p>软件开发工程师(7000-15000)</p>
									</div>
									<div>
										<p>
											上海
										</p>
									</div>
								</div>
								<div class="jobConRight">
									<p>2023-2-27更新</p>
								</div>
							</template>
							<div>
								<h3>职位描述：</h3>
								<p>1. 参与公司软件产品项目的编码工作;</p>
								<p>2. 根据需求及进度要求完成开发任务， 确保项目的进度和质量;</p>
								<p>3. 确保编码风格和质量符合公司开发规范和项目要求;</p>
								<p>4. 具备良好的代码习惯， 对软件代码进行不的定期重构和测试，提升代码质量。</p>
								<p>5. 协助项目经理做好研发项目管理工，完成项目经理交办的相关任务。</p>
							</div>
							<div>


								<h3>任职要求：</h3>
								<p>1. 全日制本科以上学历， 计算机，软件工程，建筑等相关专业;</p>
								<p>2. 优秀应届毕业生或1年以上软件开发工作经验， 具有类似平台开发管理经验优先;</p>
								<p>3. 熟悉NET， JAVA， C++， C#等语言，熟悉数据库技术;</p>
								<p>4. 工作踏实严谨，学习能力强，数学基础功扎实，逻辑思维能力强;</p>
								<p>5. 性格开朗， 具有良好的沟通能力和团队协作能力， 具有较强的事业心与责任感。</p>
							</div>
						</el-collapse-item>
						<el-collapse-item name="5">
							<template slot="title">
								<div class="jobConLeft">
									<div>
										<p>UI设计师(7000-12000)</p>
									</div>
									<div>
										<p>
											上海
										</p>
									</div>
								</div>
								<div class="jobConRight">
									<p>2023-2-27更新</p>
								</div>
							</template>
							<div>
								<h3>职位描述：</h3>
								<p>1.负责公司应用软件产品的PC端、web、移动端APP等产品美术创意、UI界面设计，包括视觉设计、交互设计、整体版式、风格设计； </p>
								<p>2.参与产品讨论，从视觉设计和用户体验的角度提出建议与解决方案，持续跟进设计效果并加以改善，保证最终设计质量； </p>
								<p>3.负责用户交互，把握客户端软件整体风格、视觉效果、用户操作体验； </p>
								<p>4.配合工程师进行手机软件界面优化，提高美观性和用户体验； </p>
								<p>5.根据产品开发需求和变更，积极配合完成产品更新和修改； </p>
								<p>6.规范产品在用户体验上的统一性和一致性，制定、维护UI设计视觉风格规范；</p>
								<p>7.负责公司宣传资料的设计;</p>
								<p>8.其他与设计相关的工作;</p>
							</div>
							<div>


								<h3>任职要求：</h3>
								<p>1.专科以上学历，艺术、美术、设计等相关专业；</p>
								<p>2.二年以上移动端和PC端的UI设计经验；</p>
								<p>3.精通AI、AE、Photoshop、sketch等相关的设计类软件；</p>
								<p>4.了解html、css等技术，熟悉计算机软件开发流程者优先；</p>
								<p>5.能够使用AxureRP绘制系统界面原型图者优先考虑；</p>
								<p>6.有较强的美术功底、出色的审美能力和良好的创意理念；</p>
								<p>7.性格随和热情，工作细心、责任心强、工作积极主动，具备一定的抗压能力，工作保质保量；</p>
								<p>8.具有良好的团队合作精神和沟通能力。</p>
							</div>
						</el-collapse-item>
						<el-collapse-item name="6">
							<template slot="title">
								<div class="jobConLeft">
									<div>
										<p>BIM土建工程师(7000-10000)</p>
									</div>
									<div>
										<p>
											上海
										</p>
									</div>
								</div>
								<div class="jobConRight">
									<p>2023-2-27更新</p>
								</div>
							</template>
							<div>
								<h3>职位描述：</h3>
								<p>1. 负责项目BIM应用过程中的技术和人员管理、BIM实施计划的编制和执行；</p>
								<p>2. 完成建筑、结构、装饰等专业BIM建筑信息模型搭建；</p>
								<p>3. 完成后期BIM技术应用；</p>
								<p>4. 负责日常BIM模型的更新维护工作；</p>
								<p>5. 项目BIM管理协调事宜。</p>
							</div>
							<div>


								<h3>任职要求：</h3>
								<p>1. 2年及以上BIM建模工作经验；</p>
								<p>2. 大专及以上学历，建筑，工程，暖通、电气、设施管理等相关专业；</p>
								<p>3. 熟练使用Revit、civil3D、Navisworks、Inventor、Tekla系列或其他产品BIM软件；</p>
								<p>4. 能根据模型要求，进行碰撞检查；有相关工程量统计，4D、5D施工动画模拟仿真方面经验者优先；</p>
								<p>5. 敬业踏实，认真严谨，致力于BIM专业发展，有良好的职业素质和团队精神及沟通协调能力；</p>
								<p>6. 有大型项目、配合施工单位、咨询单位BIM工作经验者优先；</p>
								<p>7. 能够适应项目驻场。</p>
							</div>
						</el-collapse-item>
						<el-collapse-item name="7">
							<template slot="title">
								<div class="jobConLeft">
									<div>
										<p>BIM机电工程师(8000-13000)</p>
									</div>
									<div>
										<p>
											上海
										</p>
									</div>
								</div>
								<div class="jobConRight">
									<p>2023-2-27更新</p>
								</div>
							</template>
							<div>
								<h3>职位描述：</h3>
								<p>1.负责公司应用软件产品的PC端、web、移动端APP等产品美术创意、UI界面设计，包括视觉设计、交互设计、整体版式、风格设计； </p>
								<p>2.参与产品讨论，从视觉设计和用户体验的角度提出建议与解决方案，持续跟进设计效果并加以改善，保证最终设计质量； </p>
								<p>3.负责用户交互，把握客户端软件整体风格、视觉效果、用户操作体验； </p>
								<p>4.配合工程师进行手机软件界面优化，提高美观性和用户体验； </p>
								<p>5.根据产品开发需求和变更，积极配合完成产品更新和修改； </p>
								<p>6.规范产品在用户体验上的统一性和一致性，制定、维护UI设计视觉风格规范；</p>
								<p>7.负责公司宣传资料的设计;</p>
								<p>8.其他与设计相关的工作;</p>

							</div>
							<div>

								<h3>任职要求：</h3>
								<p>1. 从事BIM相关工作2年以上；</p>
								<p>2.大专及以上学历，建筑，工程，暖通、电气、设施管理等相关专业；</p>
								<p>3. 工作仔细认真，责任心强，良好的协调沟通能力；</p>
								<p>4. 学习能力强、有上进心，公司提供BIM相关学习平台；</p>
								<p>5. 专业理论知识扎实，熟悉工程图纸，有设计、施工、造价经验者优先考虑；</p>
								<p>6. 熟练掌握BIM相关软件者（Revit、MagiCAD、Navisworks、Lumion、Fuzor等）优先考虑；</p>
								<p>7. 有BIM实际项目应用经验者（须详细说明）、大型项目、配合施工单位、咨询单位BIM工作经验者优先；</p>
								<p>8. 适应项目驻场。</p>
							</div>
						</el-collapse-item>
						<el-collapse-item name="8">
							<template slot="title">
								<div class="jobConLeft">
									<div>
										<p>BIM实习生(2000-3500)</p>
									</div>
									<div>
										<p>
											上海
										</p>
									</div>
								</div>
								<div class="jobConRight">
									<p>2023-2-27更新</p>
								</div>
							</template>
							<div>
								<h3>职位描述:</h3>
								<p>1. 协助BIM工程师进行各项目的建模、整理和上传工作； </p>
								<p>2. 协助参与公司BIM项目的基础工作； </p>
								<p>3. 完成部门负责人交办的其他工作。 </p>
							</div>
							<div>
								<h3>任职要求：</h3>
								<p>1. 专科及以上学历，有建筑、结构、暖通、给排水、电气等专业背景；</p>
								<p>2. 能够使用CAD、BIM相关软件者优先；</p>
								<p>3. 对BIM行业有兴趣，有志于投身建筑数字领域；</p>
								<p>4. 有学习能力和沟通协调能力；</p>
								<p>5. 敬业踏实，认真负责，细心严谨，有良好的团队合作精神。</p>
							</div>
						</el-collapse-item>
					</el-collapse>
					<!-- 结束 -->
				</div>
			</div>
			<!-- 联系我们 -->
			<div class="contactUs">
				<div class="homeTitle">
					<div class="homeTitleText">联系我们</div>
					<div class="homeTitleLine"></div>
				</div>
				<div class="contactUsCon" id="contactUs">
					<div id="map"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import AMapLoader from "@amap/amap-jsapi-loader";
	export default {
		data() {
			return {
				activeNames: ['0'],
				map: null,
				marker: null,
				pointIdName: ""
			}
		},
		//页面销毁时将auchorId设为空，防止其他页面进入是有锚点问题
		destroyed() {
			// localStorage.setItem("pointIdName", "null");
		},
		created() {
			document.documentElement.scrollTop = 0;
			// this.pointIdName = localStorage.getItem("pointIdName"); //获取值单个
		},
		// ////////////////
		mounted() {
			this.initMap()  //初始化地图实例 页面加载之前完成
			console.log("11")
			console.log(this.$route.query.pointIdName, "this.$route.query11")
			let pointIdName = this.$route.query.pointIdName
			if (pointIdName != undefined) {
				this.goRule(pointIdName)
			}
		},
		methods: {
			//锚点跳转
			goRule(event) {
				let id = "#" + event;
				console.log(document.querySelector(id), "document.querySelector(id)")
				document.querySelector(id).scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "nearest",
				}, true);
			},
			// 高德地图开始***********
			initMap() {
				var that = this
				AMapLoader.load({
					"key": "e417d80aba3f9b64232f47d5d439d8b5", // 申请好的Web端开发者Key，首次调用 load 时必填
					"version": "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
					"plugins": [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
					"AMapUI": { // 是否加载 AMapUI，缺省不加载
						"version": '1.1', // AMapUI 缺省 1.1
						"plugins": [], // 需要加载的 AMapUI ui插件
					}
				}).then(AMap => {
					this.map = new AMap.Map("map", {
						//设置地图显示的缩放级别
						zoom: 16,
						// 是否允许鼠标拖拽  
						dragEnable: true,
						// 鼠标滚轮放大缩小
						scrollWheel: true,
						// 双击放大缩小
						doubleClickZoom: true,
						// 键盘控制发达缩小移动旋转
						keyboardEnable: false,
						// 手势控制
						touchZoom: false,
						// center: [121.425764, 31.18051], //设置地图中心点坐标
						center: [121.425874, 31.180477], //设置地图中心点坐标
						resizeEnable: true,
						mapStyle: "amap://styles/normal",
						viewMode: '3D' //使用3D视图
					}),
						// 	// 创建一个 Marker 实例：
						this.marker = new AMap.Marker({
							position: new AMap.LngLat(121.425895,
								31.180229), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
							title: '煜豆'
						});
					// // 将创建的点标记添加到已有的地图实例：
					this.map.add([this.marker]);
					//在指定位置打开信息窗体
					(function () {
						// console.log(this)
						//构建信息窗体中显示的内容
						var info = [];
						info.push(
							"<div class='yudouDiv'><h3>上海煜豆科技有限公司</h3><p class='input-item'>电话：13774390445</p><p class='input-item'>邮箱：2397018259@qq.com</p><p class='input-item'>地址：上海市徐家汇宜山路515号环线广场1号楼19G</p></div>"
						);
						let infoWindow = new AMap.InfoWindow({
							content: info.join("") //使用默认信息窗体框样式，显示信息内容
						});
						infoWindow.open(that.map, that.map.getCenter());
					})()
				}).catch(e => {
					console.log(e);
				});
			}
			// 高德地图开始***********
		},
		// ////////////////
	}
</script>
<style lang="scss" scoped>
	.firstdayss {
		margin-bottom: 10px;

		p {
			font-style: oblique;
			margin-top: 10px;
		}
	}

	.joinUsDiv {
		width: 100%;

		.banner {
			width: 100%;
			height: 450px;
			margin-bottom: 45px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.main {}

		// 标题开始
		.homeTitle {
			width: 100%;
			text-align: center;
			margin: 0 auto;
			margin-bottom: 35px;

			.homeTitleText {
				height: 45px;
				font-size: 31px;
				color: #000;
				font-weight: 500;
				// padding: 60px 0 8px 0;
				padding: 30px 0 8px 0;
			}

			.homeTitleLine {
				width: 64px;
				height: 3px;
				background: #006fff;
				margin: 0 auto;
			}
		}

		.why,
		.job,
		.contactUs {
			width: 65%;
			margin: 0 auto;
			margin-bottom: 90px;
		}

		// 为什么加入我们开始************* 
		.why {
			// margin-bottom: 30px;

			.whyCon {
				height: 600px;

				.whyConImg {
					height: 65%;
					overflow: hidden;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.whyConItem {
					height: 35%;
					display: flex;
					flex-direction: row;

					.whyConItemChild {
						width: 25%;
						height: 100%;
						background: #fff;
						position: relative;
						box-shadow: 0px 2px 2.5px 0px rgba(0, 0, 0, 0.08);

						div {
							padding: 30px;

							h3 {
								color: #292F3A;
								margin-bottom: 20px;
								font-weight: 500;
							}

							p {
								color: #32363f;
								font-size: 14px;
								line-height: 22px;
							}

							.whyConLine {}
						}
					}
				}
			}
		}

		.whyConItemChild:hover {
			// cursor: pointer;
			border-bottom: 2px solid;
			border-image: linear-gradient(to right, #8f41e9, #0088F4) 0.8;
		}

		// 为什么加入我们结束************* 
		// 招聘信息开始*************


		.job /deep/ .el-collapse-item {
			background: #fff;
			margin-bottom: 15px;
			box-shadow: 0px 1.2px 3px 0px rgba(0, 0, 0, 0.08);
			padding: 15px;
		}

		.job /deep/ .el-collapse-item__wrap {
			border-bottom: none;
			background: none;
		}

		.job /deep/ .el-collapse {
			border: none;
		}

		.job /deep/ .el-collapse-item__header {
			border: none;
			background: none;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			width: 100%;
			position: relative;

			p {
				display: inline-block;
				font-size: 12px;
			}

			.jobConLeft,
			.jobConRight {
				position: absolute;
			}

			.jobConLeft {
				left: 0;
				display: flex;
				flex-direction: row;
			}

			.jobConRight {
				right: 40px;
			}
		}

		.jobConLeft>div:nth-child(1) p {
			font-size: 18px;
			font-weight: 500;
		}

		.jobConLeft>div:nth-child(2) p {
			border: 1px solid #409EFF;
			height: 20px;
			line-height: 20px;
			margin-left: 10px;
			padding: 0 10px;
			border-radius: 10px;
		}

		.job /deep/ .el-collapse-item__content {}

		.job /deep/ .el-collapse-item__content>div:nth-child(1) {
			margin-bottom: 10px;
		}

		.job /deep/ .el-collapse-item__content>div:nth-child(1) span {
			margin: 0 6px;
		}

		// 招聘信息结束************* 
		// 联系我们开始************* 
		.contactUsCon {
			width: 100%;
			height: 400px;

			#map {
				width: 100%;
				height: 100%;
			}
		}

		// 联系我们结束************* 
	}

	// 隐藏信息窗体关闭按钮
	.joinUsDiv /deep/ .amap-info-close {
		display: none;
	}

	.joinUsDiv /deep/ .amap-info-content h3 {
		font-size: 15px;
		margin-bottom: 5px;
	}

	.joinUsDiv /deep/ .amap-info-content p {
		font-size: 13px;
	}
</style>